export default __webpack_public_path__ + "static/media/2016_echothon2.5794c585.jpg";